import {
  Button,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  Grid,
  List,
  ListItem,
  ListItemText,
  Typography
} from '@material-ui/core';
import AttachmentIcon from '@material-ui/icons/Attachment';
import { makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import axios from 'src/utils/axios';
import {
  loadBaslandiJob,
  saveBaslandiJob
} from 'src/utils/storage/StartWorkOrder';
import CCFilePopup from '../../components/CCFilePopup';
import BasvuruNedeniSearch from '../../components/Selects/AppReasonSearch';
import { text } from '../../modules/languages/index';
import { setTask } from '../../store/actions/taskActions';
import logger from 'src/utils/logger';
const useStyles = makeStyles(() => ({
  root: {},
  content: {
    minHeight: 430
  },
  submitButtonFile: {
    width: '100%'
  },
  divider: {
    backgroundColor: '#FF9800'
  },
}));

function Aciklama({ className, FisNo, readonly, tasks, setTask }) {
  const classes = useStyles();
  const [data, setData] = useState({});
  const [CCFilePopupOpen, setCCFilePopupOpen] = React.useState(false);
  const [rapidPopup, setRapidPopup] = React.useState(false);
  const [customerAnswers, getCustomerAnswers] = useState([]);


  const handleCCFileClose = () => {
    setCCFilePopupOpen(false);
  };

  const handleRapidButton = () => {
    setRapidPopup(true);

    axios
      .get(`getRapidMontajCevaplar/${data.FisNo}`)
      .then(response => {
        getCustomerAnswers(response.data);
      })
      .catch(error => { 
      logger.error("Hata detayı:", error.message);

      });
  };

  useEffect(() => {
    let storeData = readonly
      ? Array.isArray(tasks?.tasks)
        ? tasks.tasks.filter(d => parseInt(d.FisNo) === parseInt(FisNo))
        : []
      : loadBaslandiJob();


    if (storeData?.length !== 0) {
      if (storeData && Array.isArray(storeData) && storeData.length > 0) {
        setData(storeData[0]);
      } else {
        setData({});
      }
    } else {
      setData({});
    }
  }, [FisNo, tasks.tasks, readonly]);

  const search = '';

  readonly = data?.SU_ARITMA_KONTROL === 1 ? true : readonly; // MHTU-3427

  const setModel = param => {
    if (readonly) return;

    if (!param || !param.ACIKLAMA) {
      return;
    }

    const jobs = loadBaslandiJob();
    if (!Array.isArray(jobs) || jobs.length === 0) {
      return;
    }

    const job = {
      ...jobs[0],
      BasvuruNedeni: param.ACIKLAMA
    };

    saveBaslandiJob(job);
    setData(job);
    setTask(job);
  };

  return (
    <Card className={clsx(classes.root, className)}>
      <CardHeader title={text('is_emri_aciklamalar')} />
      <Divider />
      <CardContent className={classes.content}>
        <Typography className={classes.title} color="textSecondary">
          Başvuru Nedeni
        </Typography>
        <Typography variant="h6" component="h2" gutterBottom>
          {readonly ? (
            data.BasvuruNedeni
          ) : (
            <BasvuruNedeniSearch
              setModel={setModel}
              value={
                {
                  ACIKLAMA: data.BasvuruNedeni || ''
                } || ''
              }
              searchParam={search}
              modelKodu={data.KUL_MODEL_KODU || 0}
            />
          )}
        </Typography>

        <Typography className={classes.title} color="textSecondary">
          {text('Basvuru_Notu')}
        </Typography>
        <Typography variant="h6" component="h2" gutterBottom>
          {data.BASVURU_NOTU || ''}
        </Typography>
        <Typography className={classes.title} color="textSecondary">
          {text('CagriMerkezi_Notu')}
        </Typography>
        <Typography variant="h6" component="h2" paragraph={true} gutterBottom>
          {data.SF_ACIKLAMA
            ? data.SF_ACIKLAMA.split('\n').map((i, key) => {
              return <p key={key}>{i}</p>;
            })
            : ''}
        </Typography>
        <Typography
          className={classes.title}
          color="textSecondary"
          gutterBottom
        >
          {text('cagri_tarihi')} :
          <font
            variant="h6"
            component="h2"
            style={{ fontWeight: '500', fontFamily: 'Roboto', color: 'black' }}
          >
            {data.CagriTarihi}
          </font>
        </Typography>
        <Typography
          className={classes.title}
          color="textSecondary"
          gutterBottom
        >
          {text('Randevu')} :
          <font
            variant="h6"
            component="h2"
            style={{ fontWeight: '500', fontFamily: 'Roboto', color: 'black' }}
          >
            {data.RANDEVU_BASLANGIC || ''}-{data.RANDEVU_BITIS || ''}
          </font>
        </Typography>
        <Typography className={classes.title} color="textSecondary">
          Çagrı Merkezi Geliş Marka
        </Typography>
        <Typography variant="h6" component="h2" gutterBottom>
          {data.Marka}
        </Typography>
        <Typography className={classes.title} color="textSecondary">
          {text('GelisYeri_MusteriDanismani_Arama')}
        </Typography>
        <Typography variant="h6" component="h2" gutterBottom>
          {data.GelisYeri} - {data.MusteriDanismani} - {data.ARAMA_SAYISI} Adet
        </Typography>
      </CardContent>
      <Divider />
      <CardActions>
        <Grid container spacing={1} >
          <Grid item xs={12}>
            <Button
              variant="contained"
              color="secondary"
              fullWidth
              endIcon={<AttachmentIcon>Onizleme</AttachmentIcon>}
              onClick={() => setCCFilePopupOpen(true)}
            >
              Çağrı Merkezİ Dosya
            </Button>
          </Grid>
          <Grid item xs={12}>
            <Button
              variant="contained"
              color="secondary"
              fullWidth
              endIcon={<AttachmentIcon>Onizleme</AttachmentIcon>}
              onClick={() => handleRapidButton()}
            >
              Rapİd Montaj Uygunluk
            </Button>
          </Grid>
        </Grid>
      </CardActions>
      <CCFilePopup
        onClose={handleCCFileClose}
        FisNo={FisNo}
        open={CCFilePopupOpen}
      />
      <Dialog
        open={rapidPopup}
        onClose={() => setRapidPopup(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {text('Montaj_Uygunluk')}
        </DialogTitle>
        <Divider />
        <DialogContent>
          <DialogContentText id="alert-dialog-description" component="div">
            <CardContent>
              <List>
                {customerAnswers &&
                  customerAnswers.map(log => (
                    <div key={log.InfocodeId}>
                      <Divider className={classes.divider} />
                      <ListItem alignItems="flex-start">
                        <ListItemText
                          primary={
                            <React.Fragment>
                              <Typography
                                component="span"
                                variant="body2"
                                className={classes.inline}
                                color="textPrimary"
                              >
                                Soru: {log.Description}
                              </Typography>
                              <br></br>
                            </React.Fragment>
                          }
                          secondary={
                            <React.Fragment>
                              <Typography
                                component="span"
                                variant="body2"
                                className={classes.inline}
                                color="textPrimary"
                              >
                                <b>Cevap: {log.Response}</b>
                              </Typography>
                              <br></br>
                            </React.Fragment>
                          }
                        />
                      </ListItem>
                      <Divider className={classes.divider} />
                    </div>
                  ))}
              </List>
            </CardContent>
          </DialogContentText>
        </DialogContent>
        <Divider />
        <DialogActions>
          <Button
            onClick={() => setRapidPopup(false)}
            color="primary"
            autoFocus
          >
            Kapat
          </Button>
        </DialogActions>
      </Dialog>
    </Card>
  );
}

Aciklama.propTypes = {
  className: PropTypes.string
};

export default connect(
  state => ({
    tasks: state.tasks1
  }),
  { setTask }
)(Aciklama);
